<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Post Settlement Details</h1>
      </div>
    </div>

    <form id="form7" autocomplete="off" class="pt-40">
        <div class="row Introduce-yourself-container">

            <div v-for="newContent in temp" :key="newContent.id">

                <div class="address-section">
                    <div class="address-container address-0">

                        <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <div class="flx">
                                <span>Enter your post settlement address</span>
                            </div>
                            <input class="search_address pac-target-input" type="text" placeholder="Enter a location" autocomplete="off">

                        </div>
                        </div>
                        <!-- Can't find your address? Click here-->
                        <p class="pt-10">Can't find your address? 
                        <a style="color: green;cursor: pointer" onclick="$(this).closest('.address-container').find('.address-expand').toggleClass('none')">Click here</a>
                        </p>

                        <div class="none component-9-choose-address address-expand">
                            <!--Unit Number Street Number-->
                            <div class="row">
                                <div class="col-sm-6 col-md-6">
                                    <span>Unit Number</span>
                                    <input type="text" class="field form-control">
                                </div>
                                <div class="col-sm-6 col-md-6">
                                    <span>Street Number</span>
                                    <input type="text" class="field form-control" required>
                                </div>
                            </div>
                            <!--Street Name City/Suburb-->
                            <div class="row pt-10">
                                <div class="col-sm-6 col-md-6">
                                    <span>Street Name</span>
                                    <input type="text" class="field form-control" required>
                                </div>
                                <div class="col-sm-6 col-md-6">
                                    <span>City/Suburb</span>
                                    <input type="text" class="field form-control" required>
                                </div>
                            </div>
                            <!--State Postcode-->
                            <div class="row pt-10">
                                <div class="col-sm-6 col-md-6">
                                    <span>State</span>
                                    <input type="text" class="field form-control" required>
                                </div>
                                <div class="col-sm-6 col-md-6">
                                    <span>Postcode</span>
                                    <input type="text" class="field form-control" required>
                                </div>
                            </div>
                            <!--Country-->
                            <div class="row pt-10 mb-20">
                                <div class="col-sm-6 col-md-6">
                                    <span>Country</span>
                                    <input type="text" class="field form-control" required>
                                </div>
                                <div class="col-sm-6 col-md-6">
                                    <span>How long have you been at this address?(month)</span>
                                    <input type="number" class="field form-control" required>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="clear"></div>
            
            </div>

        </div>
    </form>

    
    <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('financial-liabilities')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('additional-services')">CONTINUE</a>
    </div>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>

export default {
  props: ["onChangeStep"],
  data: ()=>{
    return {
      id: 0,
      temp: [{id: 0}],}
  },
  methods: {
    addAddress(){
      var new_id = 0;
      do{++new_id;}while(this.temp.find(e => e.id === new_id));
      this.temp.push({
        id: new_id
      })
    },
    removeAddress(event, id){
      var index = this.temp.map(object => object.id).indexOf(id);
      this.temp.splice(index,1);
    },
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};

</script>
